module.exports = __webpack_public_path__ + "static/media/gacha-banner-2.a1af0ce4.png";